import styled from "styled-components";

export const PageContainer = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const SelectContainer = styled.div`
  margin: 20px 0;
`;

export const StyledSelect = styled.select`
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ddd;
  font-size: 16px;

  &:focus {
    outline: none;
    border-color: #4a90e2;
  }
`;

export const UploadContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 20px;
`;

export const FileInput = styled.input`
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  flex: 1;
`;

export const Button = styled.button`
  padding: 8px 16px;
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #357abd;
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const SelectorContainer = styled.div`
  margin-top: 20px;
`;

export const Title = styled.h1`
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
`;

export const SubTitle = styled.h3`
  font-size: 18px;
  color: #444;
  margin: 20px 0 10px;
`;

export const SvgWrapper = styled.svg`
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: crosshair;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
`;

export const CoordinatesDisplay = styled.pre`
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  overflow-x: auto;
  font-size: 14px;
  line-height: 1.4;
`;

export const StrokeControlContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 20px 0;
`;

export const StrokeButton = styled.button`
  width: 30px;
  height: 30px;
  font-size: 24px;
  border-radius: 25px;
  border: none;
  background-color: #4a90e2;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #357abd;
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const StrokeNumber = styled.div`
  font-size: 20px;
  font-weight: bold;
  min-width: 100px;
  text-align: center;
`;

export const StrokeHint = styled.div`
  color: #666;
  font-size: 14px;
  margin-left: 10px;
`;
